import { Navigate, Outlet } from "react-router-dom";
import { AppStore } from "../redux/stores"
import { useSelector } from "react-redux"
import { PublicRoutes } from "../routes";


// interface Props {
//     privateValidation: boolean;
//   }
  

export const AuthGuard = () => {

    const userState = useSelector((store: AppStore) => store.user);
    
    return ( userState.idTramite != "" ? <Outlet /> : <Navigate replace to={ PublicRoutes.INICIO }/> );
    //return ( true ? <Outlet /> : <Navigate replace to={ PublicRoutes.INICIO }/> );

}